import React from 'react';

import Filters from './Filters';
import Calendar from './Calendar';
import Actions from './Actions';

export const AgendaRender = ({ setFilters, data, setDate, ...props }) => (
  <div>
    <Filters onChange={setFilters} data={data} />
    <Calendar onChange={setDate} data={data} {...props} />
    <Actions />
  </div>
);

export default AgendaRender;



// WEBPACK FOOTER //
// ./src/components/Agenda/AgendaRender.js